import { Seo } from '@/components/Seo';
import { ContentPage } from '@/components/PublicLayout';
import { useLang, useT } from '@/i18n/LanguageContext';
import { contactContent } from '@/i18n/content/contact';
import { pathFor } from '@/i18n/routes';
import { NewsletterForm } from '@/components/NewsletterForm';

const socials = [
  { label: 'Instagram', url: 'https://www.instagram.com/rot8ion/' },
  { label: 'LinkedIn', url: 'https://www.linkedin.com/in/rot8ion' },
  { label: 'YouTube', url: 'https://www.youtube.com/@rot8ion' },
];

export default function Contact() {
  const lang = useLang();
  const t = useT(contactContent);

  return (
    <>
      <Seo title={t.seoTitle} description={t.seoDescription} path={pathFor('contact', lang)} />
      <ContentPage title={t.title}>
        <div className="space-y-10">
          <section>
            <h2 className="text-xs font-mono tracking-[0.3em] uppercase text-sitefg/40 mb-2">
              {t.emailLabel}
            </h2>
            <a
              href="mailto:info@rot8ion.com"
              className="text-lg text-[var(--viz-accent)] hover:underline"
            >
              info [at] rot8ion.com
            </a>
          </section>

          <section>
            <h2 className="text-xs font-mono tracking-[0.3em] uppercase text-sitefg/40 mb-2">
              {t.residenceLabel}
            </h2>
            <p className="leading-relaxed text-sitefg/75">
              {t.residence[0]}
              <br />
              {t.residence[1]}
            </p>
          </section>

          <section>
            <h2 className="text-xs font-mono tracking-[0.3em] uppercase text-sitefg/40 mb-2">
              {t.socialLabel}
            </h2>
            <ul className="space-y-2">
              {socials.map((s) => (
                <li key={s.url}>
                  <a
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[var(--viz-accent)] hover:underline"
                  >
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </section>

          <section className="pt-4 border-t border-sitefg/10">
            <h2 className="text-xs font-mono tracking-[0.3em] uppercase text-sitefg/40 mb-3">
              {t.newsletterTitle}
            </h2>
            <p className="leading-relaxed text-sitefg/75 mb-4">{t.newsletterIntro}</p>
            <div className="space-y-3 text-sitefg/75 mb-6">
              {t.newsletterBody.map((p, i) => (
                <p key={i} className="leading-relaxed">
                  {p}
                </p>
              ))}
            </div>
            <NewsletterForm source="page" />
          </section>
        </div>
      </ContentPage>
    </>
  );
}
